import script from "./FlowManagerAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./FlowManagerAssistant.vue?vue&type=script&setup=true&lang=js"

import "./FlowManagerAssistant.vue?vue&type=style&index=0&id=3970c49c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3970c49c"]])

export default __exports__